import {Player} from '../../../../../types';
import {StaticData} from './StaticData';
import {ActiveData} from './ActiveData';
import {PlayerData} from './active_data/field_config/PlayerData';
import {NewGameSettings} from './dynamic_data/NewGameSettings';

export class DynamicData
{
    static sceneSizes: DOMRect;
    static handSizes: DOMRect;
    static dragSomething: boolean = false;
    static players: Player[];
    static holdingTempStacksCreated: boolean = false;
    static gridEvenDraw: boolean = false;
    static fieldClear: boolean = true;
    static settings: NewGameSettings;

    /**
     * Карта цветов игроков
     */
    static get playersColorsMap(): Map<string, string> {
        return DynamicData.players.reduce((colorsMap: Map<string, string>, player: Player) => {
            return colorsMap.set(player.id, player.color.code);
        }, new Map<string, string>());
    }

    /**
     * Получить всех активных игроков отличных от собственного
     */
    static getNotMyActivePlayers(): PlayerData[] {
        return DynamicData.players
            .filter(player => player.isActive && !player.isGuest && player.id != StaticData.playerId)
            .map(player => ActiveData.root.players.classes.find(playerData => player.id == playerData.id)!);
    }

    /**
     * Применить дефолтные настройки доступа к дейтвиям со столом/картами (всё разрешено)
     */
    static applyDefaultPermissions(): void {
        // @ts-ignore
        DynamicData.settings = {};
        DynamicData.settings.canViewTableMenu = true;
        DynamicData.settings.canViewShortcuts = true;
        DynamicData.settings.canTableRotateCards = true;
        DynamicData.settings.canTablePreviewCards = true;
        DynamicData.settings.canTableLockCards = true;
        DynamicData.settings.canTableDeleteCards = true;
        DynamicData.settings.canTableFlipCards = true;
        DynamicData.settings.canTableTakeCards = true;
    }
}
